import { toast, Bounce } from "react-toastify";

export function ToastMessgae(result) {
  // Handle both result objects and message objects
  if (typeof result === "object" && result.message && result.type) {
    // New format: { message: "...", type: "success|error|warning|info" }
    switch (result.type) {
      case "success":
        toast.success(result.message, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        break;
      case "error":
        toast.error(result.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        break;
      case "warning":
        toast.warning(result.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        break;
      default:
        toast.info(result.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
    }
  } else if (result?.code === 200 || result?.code === 201) {
    // Original format: result object with code
    toast.success(result?.message, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  } else {
    // Error case
    toast.error(result?.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  }
}

// Utility function to handle token expiration consistently
export const handleTokenExpiration = (error, navigate) => {
  if (
    error.response &&
    (error.response.status === 401 || error.response.status === 403)
  ) {
    // Clear localStorage
    localStorage.clear();

    // Show toast message
    ToastMessgae({
      message: "Session expired. Please login again.",
      type: "error",
    });

    // Navigate to login if navigate function is provided
    if (navigate) {
      navigate("/login");
    } else {
      // Fallback to window.location if navigate is not available
      window.location.href = "/login";
    }

    return true; // Indicates token expiration was handled
  }
  return false; // Indicates no token expiration
};
